import { useBlackBaudAuthFlow, buildNangoConfig, PROVIDER_BB_RENXT } from "./blackbaud-auth-flow";

export const useBlackBaudRenxtAuthFlow = () => {
  return useBlackBaudAuthFlow(buildNangoConfig(PROVIDER_BB_RENXT));
};

export default useBlackBaudRenxtAuthFlow;